const RIGHT_TYPE_OPTIONS = Object.freeze({
  WRITE: 'write',
  READ: 'read',
  REMOVE: 'remove',
} as const)

export type RightType = (typeof RIGHT_TYPE_OPTIONS)[keyof typeof RIGHT_TYPE_OPTIONS]

export { RIGHT_TYPE_OPTIONS }
